import type { TypographyProps } from "../../atoms/typography";

type TypographyColor = NonNullable<TypographyProps["color"]>;

type TabItemState = "active-disabled" | "active" | "disabled" | "default";

export function getTabItemState(active: boolean, disabled: boolean): TabItemState {
  if (active && disabled) return "active-disabled";
  if (active) return "active";
  if (disabled) return "disabled";
  return "default";
}

// Figma's Tabs (68:3977): an inactive tab is intermediate, a disabled one
// attenuated
export const tabIconColor: Record<TabItemState, string> = {
  "active-disabled": "text-luce-neutral-foreground-attenuated",
  active: "text-luce-brand-primary",
  disabled: "text-luce-neutral-foreground-attenuated",
  default: "text-luce-neutral-foreground-intermediate",
};

// One hover look, Label only's (68:4218; Ardhi's DQ15 (b) answer, 2026-11-03):
// an unselected, enabled tab's label and icon darken while a pointer that
// hovers is over it, as its fill does
export const tabHoverColor: Record<TabItemState, string> = {
  "active-disabled": "",
  active: "",
  disabled: "",
  default: "[@media(hover:hover)]:group-hover:text-luce-neutral-foreground-default",
};

export const tabTypographyColor: Record<TabItemState, TypographyColor> = {
  "active-disabled": "neutral-foreground-attenuated",
  active: "brand-primary",
  disabled: "neutral-foreground-attenuated",
  default: "neutral-foreground-intermediate",
};
